import * as React from 'react';
import { IAPanel } from '../panels/Panel';
import { StockPhotos } from './StockPhotos';
export interface IProps {
  open: boolean;
  close: () => void;
  onSelect: (image: string, lastModified?: string) => void;
  highlightColor: string;
  isMobile: boolean;
  environment: "Development" | "Test" | "Production";
  tenant: string;
  token: string;
  marginTop: number;
}

export class StockPhotosPanel extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);
  }

  public render(): JSX.Element {
    return (
      <IAPanel
        open={this.props.open}
        transition={"slide"}
        showNavigationBar={true}
        marginTop={this.props.marginTop}
        width={this.props.isMobile ? window.innerWidth : 1000}
        isMobile={this.props.isMobile}
        close={() => this.props.close()}
      >
        <StockPhotos
          isMobile={this.props.isMobile}
          environment={this.props.environment}
          token={this.props.token}
          tenant={this.props.tenant}
          open={this.props.open}
          highlightColor={this.props.highlightColor}
          close={() => this.props.close()}
          onSelect={(image, lastModified) => this.props.onSelect(image, lastModified)}
        >
        </StockPhotos>
      </IAPanel>
    );
  }
}
